import { apiClient } from './api';

/**
 * Sync Service
 * Triggers data sync from IronSource API into the dashboard database
 */
export const syncService = {
  /**
   * Trigger apps sync (fetches app list from IronSource and stores in DB)
   * @param {number} [accountId] - Optional account ID
   * @returns {Promise}
   */
  triggerAppsSync: (accountId = null) => {
    const body = { sync_type: 'apps' };
    if (accountId != null) body.account_id = accountId;
    return apiClient.post('/sync/trigger', body);
  },

  /**
   * Fetch historical revenue/stats for a date range and store in DB
   * @param {string} startDate - YYYY-MM-DD
   * @param {string} endDate - YYYY-MM-DD
   * @param {number} [accountId] - Optional account ID
   * @returns {Promise}
   */
  fetchHistoricalData: (startDate, endDate, accountId = null) => {
    const body = { start_date: startDate, end_date: endDate };
    if (accountId != null) body.account_id = accountId;
    return apiClient.post('/analytics/historical/fetch', body);
  },

  /**
   * Get sync status for an account
   * @param {number} [accountId] - Optional account ID
   * @param {string} [syncType] - Optional sync type filter (e.g., 'revenue', 'apps')
   * @returns {Promise}
   */
  getSyncStatus: (accountId = null, syncType = null) => {
    const params = {};
    if (accountId != null) params.account_id = accountId;
    if (syncType != null) params.sync_type = syncType;
    return apiClient.get('/sync/status', params);
  },
};
